import { styled } from 'styled-components';

export const StyledButtons = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
`;
